import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";

const { carbon } = colorsPalettes;

export const SingleCountry = styled.div`
    .DropdownButton-country {
        pointer-events: none;
        cursor: default;
        ${setFontVariant("input2", carbon[400])}
    }

    .icon-arrow {
        display: none;
    }
`;
